<template>
<div class="form-group row">
    <div class="col-lg-12">
        <input data-show-preview="false" type="file" :class="['file-input', classCustom]" @change="uploadImage($event)" :accept="acceptFiles ? acceptFiles : '*'" data-fouc>
        <!-- <span class="form-text text-muted">Automatically convert a file input to a bootstrap file input widget by setting its class as <code>file-input</code>.</span> -->
    </div>
</div>
</template>

<script>
export default {
    props: ['acceptFiles'],
    data() {
        return {
            classCustom: Math.random().toString(36).substring(2, 7)
        }
    },
    methods: {
        async uploadImage(event) {
            let fileData = {
                base64: null,
                blob: null,
                file: null
            };
            const file = event.target.files[0];
            let blob = URL.createObjectURL(file);
            fileData.blob = blob;
            const reader = new FileReader();
            await reader.readAsDataURL(file);
            reader.onload = e => {
                fileData.base64 = e.target.result;
                fileData.file = file;
                this.$emit('change', fileData);
            };
            // fileData.file = file;
            // this.$emit('change', fileData);
        },
    },
    mounted() {
        var vm = this;
        let fileData = {
            base64: null,
            blob: null,
            file: null
        };
        let translate = {
            dragAndDrop: this.$t('Drag & drop files here …'),
            noFileSelected: this.$t('No file selected'),
            browse: this.$t('Browse')
        }
        _componentFileUpload(translate);
        $('.' + vm.classCustom).on('fileclear', function (event) {
            vm.$emit('change', fileData);
        });
        $('.' + vm.classCustom).on('fileloaded', function(event, file, previewId, fileId, index, reader) {
            vm.uploadImage(event);
        });
    }
}
function _componentFileUpload(translate) {
    // Modal template
    var modalTemplate = '<div class="modal-dialog modal-lg" role="document">\n' +
        '  <div class="modal-content">\n' +
        '    <div class="modal-header align-items-center">\n' +
        '      <h6 class="modal-title">{heading} <small><span class="kv-zoom-title"></span></small></h6>\n' +
        '      <div class="kv-zoom-actions btn-group">{toggleheader}{fullscreen}{borderless}{close}</div>\n' +
        '    </div>\n' +
        '    <div class="modal-body">\n' +
        '      <div class="floating-buttons btn-group"></div>\n' +
        '      <div class="kv-zoom-body file-zoom-content"></div>\n' + '{prev} {next}\n' +
        '    </div>\n' +
        '  </div>\n' +
        '</div>\n';
    // Buttons inside zoom modal
    var previewZoomButtonClasses = {
        toggleheader: 'btn btn-light btn-icon btn-header-toggle btn-sm',
        fullscreen: 'btn btn-light btn-icon btn-sm',
        borderless: 'btn btn-light btn-icon btn-sm',
        close: 'btn btn-light btn-icon btn-sm'
    };
    // Icons inside zoom modal classes
    var previewZoomButtonIcons = {
        prev: '<i class="icon-arrow-left32"></i>',
        next: '<i class="icon-arrow-right32"></i>',
        toggleheader: '<i class="icon-menu-open"></i>',
        fullscreen: '<i class="icon-screen-full"></i>',
        borderless: '<i class="icon-alignment-unalign"></i>',
        close: '<i class="icon-cross2 font-size-base"></i>'
    };
    // File actions
    var fileActionSettings = {
        zoomClass: '',
        zoomIcon: '<i class="icon-zoomin3"></i>',
        dragClass: 'p-2',
        dragIcon: '<i class="icon-three-bars"></i>',
        removeClass: '',
        removeErrorClass: 'text-danger',
        removeIcon: '<i class="far fa-trash-alt"></i>',
        indicatorNew: '<i class="icon-file-plus text-success"></i>',
        indicatorSuccess: '<i class="icon-checkmark3 file-icon-large text-success"></i>',
        indicatorError: '<i class="icon-cross2 text-danger"></i>',
        indicatorLoading: '<i class="icon-spinner2 spinner text-muted"></i>'
    };
    // <i class="fa-solid fa-file-circle-plus"></i>
    $('.file-input').fileinput({
        browseLabel: translate.browse,
        browseIcon: '<i class="fa-solid fa-file-circle-plus mr-2"></i>',
        uploadIcon: '<i class="icon-file-upload2 mr-2"></i>',
        removeIcon: '<i class="icon-cross2 font-size-base mr-2"></i>',
        layoutTemplates: {
            icon: '<i class="icon-file-check"></i>',
            modal: modalTemplate
        },
        dropZoneTitle: translate.dragAndDrop,
        initialCaption: translate.noFileSelected,
        showRemove: false,
        showUpload: false,
        autoOrientImage: false,
        previewZoomButtonClasses: previewZoomButtonClasses,
        previewZoomButtonIcons: previewZoomButtonIcons,
        fileActionSettings: fileActionSettings
    });
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/restock/UploaderBootstrap.vue